
export default {
    name: 'ActiveBonus',
    props: {
        player: {
            type: Object,
            default: () => {},
        },
        item: {
            type: Object,
            default: () => {},
        },
    },
}
